import { IconText } from './Amount';
import { EventCard, GroupChangeLine, costsFirst, RankingLines } from './SinceLastTurn';
import CollapsedCard from './CollpasedCard';
const CardConverter = require('@tta/engine/Utilities/Converters/CardConverter');

// The finished game, in place of "since your last turn": the winners, the standings (culture before the final scoring,
// what it added, the total), and what each part of the final scoring did: each event as its card (hover for what it
// does), then what it did to each player, as in the recap. Then the events each player prepared over the game.
function GameOver({Finished, PlayerColors, Players, Prepared})
{
    const colorOf = (name) => PlayerColors[Players.findIndex(p => p.name === name)];
    const best = Finished.standings[0]?.culture;
    return (
        <div className="tta tta-left tta-game-over">
            <div className="tta-game-over-title">
                Game over: {Finished.winners.map((name, index) =>
                    <span key={name}>{index > 0 && ' and '}<span style={{ color: colorOf(name) }}>{name}</span></span>)}
                {' '}win{Finished.winners.length === 1 ? 's' : ''} with <IconText text={`${best} culture`}/>
            </div>
            <div style={{ display: 'flex', gap: '28px', flexWrap: 'wrap' }}>
                <table className="tta-target-table" style={{ width: 'auto' }}>
                    <thead>
                        <tr><th></th><th>Player</th><th>Before final scoring</th><th>Final scoring</th><th>Culture</th></tr>
                    </thead>
                    <tbody>
                        {Finished.standings.map(entry =>
                            <tr key={entry.player}>
                                <td>{Finished.standings.filter(other => other.culture > entry.culture).length + 1}.</td>
                                <td style={{ color: colorOf(entry.name), fontWeight: 'bold' }}>{entry.name}</td>
                                <td>{entry.beforeFinalScoring}</td>
                                <td>{entry.culture - entry.beforeFinalScoring >= 0 ? '+' : ''}{entry.culture - entry.beforeFinalScoring}</td>
                                <td><b>{entry.culture}</b></td>
                            </tr>)}
                        {Finished.resigned.map(name =>
                            <tr key={name} className="tta-muted">
                                <td></td><td style={{ color: colorOf(name) }}>{name}</td><td colSpan={3}>resigned</td>
                            </tr>)}
                    </tbody>
                </table>
                {Finished.finalScoring.length > 0 &&
                    <div style={{ flex: '1 1 420px' }}>
                        <div className="tta-since-title">Final scoring</div>
                        {Finished.finalScoring.map((report, index) =>
                            <div key={index} className="tta-since-event">
                                <div>
                                    <EventCard event={report}/>
                                    {report.revealedBy && <span className="tta-muted"> ({report.card ? 'prepared by ' : ''}<span style={{ color: colorOf(report.revealedBy) }}>{report.revealedBy}</span>)</span>}
                                    {/* (No card, e.g. a card's own end-of-game scoring: what scored, in words) */}
                                    {!report.card && <>: <IconText text={report.text}/></>}
                                </div>
                                {/* What an impact compared (e.g. culture production), to check the ranks */}
                                <RankingLines rankings={report.rankings} colorOf={colorOf}/>
                                {/* An event: every player's score from it, even 0 (e.g. Impact of Wonders for someone with none) */}
                                {(report.card ? Finished.standings.map(entry => entry.name) : (report.changes ?? []).map(entry => entry.player)).map(name => {
                                    const changes = report.changes?.find(entry => entry.player === name)?.changes ?? [];
                                    const scored = changes.some(change => change.stat === 'culture') ? changes : [{ stat: 'culture', label: 'culture', change: 0 }, ...changes];
                                    return <GroupChangeLine key={name} group={{ players: [name], changes: costsFirst(scored) }} colorOf={colorOf}/>;
                                })}
                            </div>)}
                    </div>}
            </div>
            {Prepared && <PreparedEvents Prepared={Prepared} colorOf={colorOf}/>}
        </div>
    );
}

// Who prepared which events, each player's in the order they prepared them; Confucius's non-events only as a count
// at the end (which cards they were is never told)
function PreparedEvents({Prepared, colorOf})
{
    const nonEvents = Prepared.filter(entry => entry.nonEvents > 0);
    return <div className="tta-prepared-events">
        <div className="tta-since-title">Events prepared</div>
        {Prepared.map(entry =>
            <div key={entry.player} className="tta-prepared-row">
                <span className="tta-prepared-name" style={{ color: colorOf(entry.player) }}>{entry.player}</span>
                <span className="tta-muted tta-prepared-count">{entry.events.length}</span>
                <span className="tta-prepared-cards">
                    {entry.events.length === 0 ? <span className="tta-muted">none</span>
                        : entry.events.map((card, index) =>
                            <span key={index} className="tta-card-token"><CollapsedCard card={CardConverter({ ...card, id: -1 - index })}/></span>)}
                </span>
            </div>)}
        {nonEvents.length > 0 && <div className="tta-muted tta-prepared-note">
            Also prepared as non-events (Confucius): {nonEvents.map((entry, index) =>
                <span key={entry.player}>{index > 0 && ', '}<span style={{ color: colorOf(entry.player) }}>{entry.player}</span> {entry.nonEvents}</span>)}
        </div>}
    </div>;
}

export default GameOver;
